/* eslint-disable react/no-did-mount-set-state,func-names,jsx-a11y/no-static-element-interactions,no-nested-ternary,no-loop-func,no-plusplus */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Headroom from 'react-headroom';
import {NavLink} from "react-router-dom";
import {SlideDown} from 'react-slidedown'
import './Header.scss';
import {trackEventByUrl} from "../../helpers/events";
import KnowledgeCenter from "../KnowledgeCenter/KnowledgeCenter";
import KnowledgeCenterSidebar from "../KnowledgeCenter/KnowledgeCenterSidebar";
import SubNav from "./SubNav";
import MegaMenu from "./MegaMenu";
import MobileMenu from "./MobileMenu";
import KnowledgeCenterQuery from "../KnowledgeCenter/KnowledgeCenterQuery";

class Header extends Component {

    static propTypes = {
        disableHeaderSocial: PropTypes.bool,
        disableHeaderNav: PropTypes.bool,
        disableHeaderLogo: PropTypes.bool,
        logo: PropTypes.string,
        logoAlt: PropTypes.string,
        menuClass: PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        subNav: PropTypes.string
    };

    static defaultProps = {
        disableHeaderSocial: false,
        disableHeaderNav: false,
        disableHeaderLogo: false,
        logo: '/public/images/global/logo_black.svg',
        logoAlt: 'MarketAxess',
        menuClass: '',
        subNav: null
    };

    constructor() {
        super();
        this.clickToggleMenu = this.clickToggleMenu.bind(this);
    }

    state = {
        mobileNavDropDowns: {},
        knowledge_center_items: [],
        knowledge_center_items_api_call_completed: false
    };

    async componentDidMount() {

        if (!this.state.knowledge_center_items_api_call_completed) {
            const knowledgeCenterItems = await KnowledgeCenterQuery.getKnowledgeCenterItems();

            if (knowledgeCenterItems.length && !this.state.knowledge_center_items.length) {
                this.setState({
                    knowledge_center_items: knowledgeCenterItems,
                    knowledge_center_items_api_call_completed: true,
                })
            } else {
                this.setState({
                    knowledge_center_items_api_call_completed: true,
                })
            }
        }

        /**
         * Handles toggling the navigation menu for small screens and enables TAB key
         * navigation support for dropdown menus.
         */
        let i;
        let len;

        const container = document.getElementById('site-navigation');
        if (!container) {
            return;
        }

        const button = document.getElementById('menu-toggle');
        if (typeof button === 'undefined') {
            return;
        }

        const menu = document.getElementById('mobile-nav');

        const menuMain = document.getElementById('headerNav');
        if (!menuMain) return;

        // Hide menu toggle button if menu is empty and return early.
        if (typeof menu === 'undefined') {
            button.style.display = 'none';
            return;
        }

        // Sibling function
        // const getSiblings = (elem) => {
        // 	const siblings = [];
        // 	let sibling = elem.parentNode.firstChild;
        // 	for (; sibling; sibling = sibling.nextSibling) {
        //         // eslint-disable-next-line no-continue
        // 		if (sibling.nodeType !== 1 || sibling === elem) continue;
        // 		siblings.push(sibling);
        // 	}
        // 	return siblings;
        // };

        const addClassName = (el, className) => {
            const element = el;
            if (element.classList) {
                element.classList.add(className);
            } else {
                element.className = `${element.className}${className}`;
            }
        };

        const removeClassName = (el, className) => {
            const element = el;
            if (element.classList) {
                element.classList.remove(className);
            } else {
                element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
            }
        };

        const mobileMenuActivate = () => {
            if (window.matchMedia("(max-width: 768px)").matches) {
                addClassName(button, 'active');
                addClassName(menu, 'active');
            } else {
                removeClassName(button, 'active');
                removeClassName(menu, 'active');
            }
        };

        mobileMenuActivate();
        window.addEventListener("resize", mobileMenuActivate, false);

        menu.setAttribute('aria-expanded', 'false');
        if (menu.className.indexOf('nav-menu') === -1) {
            menu.className += ' nav-menu';
        }

        const closeMenu = () => {
            container.className = container.className.replace(' toggled', '');

            removeClassName(button, 'closed-burger');

            removeClassName(menu, 'open-menu');
            addClassName(menu, 'closed-menu');

            document.body.style.overflow = "auto";
            document.body.style.height = "auto";

            menu.querySelector('a').setAttribute('tabindex', -1);

            button.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-expanded', 'false');

            setTimeout(() => {
                addClassName(button, 'active');
            }, 200);
            setTimeout(() => {
                removeClassName(menu, 'active');
            }, 300);
        };

        // Mobile menu click functionality
        button.onclick = function () {
            if (container.className.indexOf('toggled') !== -1) {
                closeMenu();
            } else {
                container.className += ' toggled';

                removeClassName(button, 'active');
                addClassName(button, 'closed-burger');

                removeClassName(menu, 'closed-menu');
                removeClassName(menu, 'active');
                addClassName(menu, 'open-menu');

                document.body.style.overflow = "hidden";
                document.body.style.height = "100%";

                menu.querySelector('a').setAttribute('tabindex', 0);

                button.setAttribute('aria-expanded', 'true');
                menu.setAttribute('aria-expanded', 'true');
            }
        };


        // Get all the link elements within the menu.
        // const links = menu.getElementsByTagName('a');
        const subMenus = menu.getElementsByTagName('ul');

        // const linksMegaMenu = document.querySelectorAll('.megaMenu > li.site-nav__menu-item--children > a');
        const subMenusMegaMenu = document.querySelectorAll('.megaMenu > li.site-nav__menu-item--children > a + div');

        /**
         * Sets or removes .focus class on an element.
         */
        // function handleMenuClose()  {
        //     closeMenu();
        // }

        function getPreviousSibling (elem, callback) {

        	// Get the next sibling element
        	let sibling = elem.previousElementSibling;

        	// If there's no callback, return the first sibling
        	if (!callback || typeof callback !== 'function') return sibling;

        	// If the sibling matches our test condition, use it
        	// If not, jump to the next sibling and continue the loop
        	let index = 0;
        	while (sibling) {
        		if (callback(sibling, index, elem)) return sibling;
        		index++;
        		sibling = sibling.previousElementSibling;
        	}

            return sibling;

        }

        // Set menu items with submenus to aria-haspopup="true".
        for (i = 0, len = subMenus.length; i < len; i += 1) {
            subMenus[i].parentNode.setAttribute('aria-haspopup', 'true');
        }

        for (i = 0, len = subMenusMegaMenu.length; i < len; i += 1) {
            const link = getPreviousSibling(subMenusMegaMenu[i]);
            const subMenu = subMenusMegaMenu[i];
            link.setAttribute('aria-haspopup', 'true');
            link.setAttribute('aria-expanded', 'false');
            subMenu.setAttribute('aria-expanded', 'false');

            link.onClick = function (e) {
                e.preventDefault();


                removeClassName(this.parentNode.parentNode.children, 'menuOpen');

                this.parentNode.children.setAttribute('aria-expanded', 'false');

                this.parentNode.classList.toggle('menuOpen');

                if ( this.parentNode.classList.contains('menuOpen') ) {
                    this.parentNode.children.setAttribute('aria-expanded', 'true');
                } else {
                    this.parentNode.children.setAttribute('aria-expanded', 'false');
                }

                return false;
            };


        }

        // // Each time a menu link is focused or blurred, toggle focus.
        // for (i = 0, len = links.length; i < len; i += 1) {
        //     links[i].addEventListener('click', handleMenuClose, true);
        // }

        // Close mega menu with ESC key
        window.addEventListener('keydown', (e) => {
            if(e.key === 'Escape') {
                const menus = document.getElementsByClassName('menuOpen');
                const menuLinks = document.getElementsByClassName('hasOpenMenu');
                if(menus) {
                    for(i = 0; i < menus.length; i++) {
                        menus[i].setAttribute('aria-expanded', false);
                        menus[i].classList.remove('menuOpen');
                    }
                }
                if(menuLinks) {
                    for(i = 0; i < menuLinks.length; i++) {
                        menuLinks[i].setAttribute('aria-expanded', false);
                        menuLinks[i].classList.remove('hasOpenMenu');
                    }
                }
            }
        })

        // Close an open mega menu when clicked outside
        window.addEventListener('click', (e) => {
            const menus = document.getElementsByClassName('menuOpen');
            const menuLinks = document.getElementsByClassName('hasOpenMenu');
            if(menus && menus.length && menus[0] && !menus[0].contains(e.target) && !menus[0].parentNode.contains(e.target)) {
                menus[0].setAttribute('aria-expanded', false);
                menus[0].previousSibling.setAttribute('aria-expanded', false);
                menus[0].classList.remove('menuOpen');
                if(menuLinks) {
                    for(i = 0; i < menuLinks.length; i++) {
                        menuLinks[i].setAttribute('aria-expanded', false);
                        menuLinks[i].classList.remove('hasOpenMenu');
                    }
                }
            }
        })


    } // end componentDidMount


    /**
     * Recursively fetch nav items
     *
     * @param menuType
     * @param link
     * @param isChild
     * @param index
     * @return {XML}
     */
    getNavItems = (menuType='site', link, isChild=false, index=null) => {
        const dropdowns = this.state.mobileNavDropDowns;
        let navClass = `${menuType}-nav__menu-item`;
        let addChildIndicator = null;
        // let addParentAttr = null;
        if (link && link.links && link.links.length) {
            navClass = `${navClass} ${menuType}-nav__menu-item--children`;

            if (menuType === 'mobile') {
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                addChildIndicator = (<i key={`mobile_${index}_${link}`} className={`fal fa-angle-down arrow${dropdowns[index] ? ' open' : ''}`} aria-hidden="false" onClick={() => {
                    dropdowns[index] = !dropdowns[index];
                    this.setState({mobileNavDropDowns: dropdowns});
                }} />);

                // addParentAttr = `aria-hidden="${dropdowns[index]}"`;
            }

        }
        if (isChild) {
            navClass = `${navClass} ${menuType}-nav__menu-item--child`;
        }

        return (
            <React.Fragment>
                <li key={`${index}_${link}`} className={navClass} id={`menu-item-${index}`}>

                    <a onClick={(e) => {
                        if(menuType === 'mobile') {
                            dropdowns[index] = !dropdowns[index];
                            this.setState({mobileNavDropDowns: dropdowns});
                        } else {
                            this.clickToggleMenu(e)
                        }
                    }} href={isChild && !link.links ? link.url.path : null} className={isChild && !link.links ? 'lastChild' : (!isChild && link.links) ? 'parentLink' : ''} {...((menuType === 'mobile') && (link && link.links && link.links.length) && (dropdowns[index] !== undefined) ? { "aria-expanded": dropdowns[index]} : (menuType === 'mobile') && (link && link.links && link.links.length) ? { "aria-expanded": "false" } : {})}>

                        <span>
                            {link.label}
                        </span>
                    </a>
                    {addChildIndicator}

                    {menuType === 'mobile' ? (
                        <SlideDown closed={!dropdowns[index]}>
                            {this.renderChildSubNavMobile(link, menuType, dropdowns, index)}
                        </SlideDown>
                    ) : menuType !== 'mobile' && isChild ? (
                        this.renderChildSubNav(link, menuType, dropdowns, index)
                    ) : this.renderSubNav(link, menuType, dropdowns, index)}

                </li>

                {isChild && !link.links && link.url && link.url.path && link.url.path === '/knowledge' && link.label === 'All Categories' ? (
                    this.renderKnowledgeCenterLinks()
                ) : null}
            </React.Fragment>
        )
    };



    clickToggleMenu = (e) => {

        // Get the list element containing the megamenu
        let megaMenuTab = e.target.parentNode.parentNode;
        if(e.target.parentNode.className.includes('site-nav')) {
            megaMenuTab = e.target.parentNode;
        }

        // Close any other open menus except the current one
        const menus = document.getElementsByClassName('menuOpen');
        if(menus && menus.length) {
            for(let i = 0; i < menus.length; i++) {
                const menu = menus[i];
                if(megaMenuTab.id !== menu.parentNode.id) {
                    menu.classList.remove('menuOpen')
                    menu.setAttribute('aria-expanded', false);
                    menu.previousSibling.classList.remove('hasOpenMenu');
                    menu.previousSibling.setAttribute('aria-expanded', false);
                }
            }
        }

        // Toggle the class name and aria-expanded of current menu
        if(megaMenuTab && megaMenuTab.children) {
            for(let i = 0; i < megaMenuTab.children.length; i++) {
                const element = megaMenuTab.children[i];
                element.classList.toggle(i === megaMenuTab.children.length - 1 ? 'menuOpen' : 'hasOpenMenu');
                element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') !== 'true');
            }
        }
    }

    removeClassName = (el, className) => {
        const element = el;
        if (element.classList) {
            element.classList.remove(className);
        } else {
            element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
        }
    };

    hoverToggleMenu = (e) => {
        // Get the list element containing the megamenu
        let megaMenuTab = e.target.parentNode.parentNode;
        if(e.target.parentNode.className.includes('site-nav')) {
            megaMenuTab = e.target.parentNode;
        }

        const menus = document.getElementsByClassName('menuOpen');
        if(menus.length && (menus[0].parentNode.id !== megaMenuTab.id || menus[0].className.includes('clickedOpen'))) return null;

        let isOpen = false;
        megaMenuTab.children.forEach((element, index) => {
            if(index === megaMenuTab.children.length - 1) {
                element.classList.toggle('menuOpen');
                isOpen = true;
            }
            element.setAttribute('aria-expanded', isOpen);
        });

        return null;
    }

    renderChildSubNav = (link, menuType, dropdowns, index) =>
        link && link.links && link.links.length > 0 ? (
            <ul className={`${menuType}-nav__menu--secondary`}>
                {link.links.filter(childLink => childLink.url.path).map((childLink, childIndex) => this.getNavItems('site', childLink, true, `${index}_${childIndex}`))}
            </ul>
        ) : null;

    renderChildSubNavMobile = (link, menuType, dropdowns, index) =>
    link && link.links && link.links.length > 0 ? (
        <ul className={`${menuType}-nav__menu--secondary`}>
            {link.links.filter(childLink => childLink.url.path).map((childLink, childIndex) => this.getNavItems('mobile', childLink, true, `${index}_${childIndex}`))}
        </ul>
    ) : null;

    renderSubNav = (link, menuType, dropdowns, index) =>
        link && link.links && link.links.length > 0 ? (
            <div className="megaMenuWrapper">
                <div className="container">
                    <ul className={`${menuType}-nav__menu--primary`}>
                        {link.links.filter(childLink => childLink.url.path).map((childLink, childIndex) => this.getNavItems('site', childLink, true, `${index}_${childIndex}`))}
                    </ul>
                </div>
            </div>
        ) : null;

    renderKnowledgeCenterLinks = () => {
        const knowledgeCenterItems = this.state.knowledge_center_items;

        const unfilteredKeywords = KnowledgeCenter.getKeywords([...knowledgeCenterItems]);

        const keywords = KnowledgeCenterSidebar.getFilteredKeywords(unfilteredKeywords);

        return (
            <React.Fragment>
                {keywords.filter(keyword => keyword).map(keyword => (
                    <li key={`menu-item-keyword_${keyword}`} id={`menu-item-keyword_${keyword}`} className="site-nav__menu-item site-nav__menu-item--child">
                        <a href={`/knowledge/?keyword=${keyword}`} className="lastChild">
                            <span>
                                {keyword}
                            </span>
                        </a>
                    </li>
                ))}
            </React.Fragment>
        );
    }

    render() {

        if (!this.state.knowledge_center_items_api_call_completed && this.props.disableHeaderSocial && this.props.disableHeaderNav && this.props.disableHeaderLogo) return null;

        return (
            <Headroom calcHeightOnResize disableInlineStyles style={{
                zIndex: '9999'
            }}>
                <header className={`site-header ${this.props.menuClass}`} role="banner">
                    {!this.props.disableHeaderSocial && (
                        <div className="site-header__top-nav">
                            <div className="container">
                                <ul>
                                    <li className="top-nav__social">
                                        <a href="https://twitter.com/MarketAxess" target="_blank" rel="noopener noreferrer" onClick={() => trackEventByUrl('https://twitter.com/MarketAxess', 'View Twitter Page')}><i className="fab fa-x-twitter" /></a>
                                    </li>
                                    <li className="top-nav__social">
                                        <a href="https://www.linkedin.com/company/marketaxess" target="_blank" rel="noopener noreferrer" onClick={() => trackEventByUrl('https://www.linkedin.com/company/marketaxess', 'View LinkedIn Page')}><i className="fab fa-linkedin" /></a>
                                    </li>
                                    <li className="top-nav__social">
                                        <a href="https://instagram.com/marketaxess" target="_blank" rel="noopener noreferrer" onClick={() => trackEventByUrl('https://instagram.com/marketaxess', 'View Instagram Page')}><i className="fab fa-instagram" /></a>
                                    </li>
                                    <li className="top-nav__button">
                                        <a href="https://investor.marketaxess.com/overview/default.aspx" onClick={() => trackEventByUrl('https://investor.marketaxess.com/overview/default.aspx', 'Investor Relations')}>Investor Relations</a>
                                    </li>
                                    <li className="top-nav__button">
                                        <a href="/careers" onClick={() => trackEventByUrl('/careers', 'Careers')}>Careers</a>
                                    </li>
                                    <li className="top-nav__button">
                                        <a href="/contact-us" onClick={() => trackEventByUrl('/contact-us', 'Contact Us')}>Contact Us</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}

                    {(!this.props.disableHeaderNav || !this.props.disableHeaderLogo) && (
                        <div id="site-navigation" className="site-header__site-nav">
                            <div className="container">
                                <NavLink to="/" className="site-header__branding" style={this.props.disableHeaderLogo ? {visibility: 'hidden'} : {}}>
                                    <img src={this.props.logo} alt={this.props.logoAlt}/>
                                </NavLink>

                                <nav id="headerNav" className="site-nav__menu--main nav-menu" style={this.props.disableHeaderNav ? {visibility: 'hidden'} : {}}>
                                    <MegaMenu />
                                </nav>

                                <button id="menu-toggle" className="menu-toggle" aria-controls="mobile-menu" aria-expanded="false" style={this.props.disableHeaderNav ? {visibility: 'hidden'} : {}}>
                                    <div className="toggle-icon">
                                        <span className="line line-top"/>
                                        <span className="line line-middle"/>
                                        <span className="line line-bottom"/>
                                    </div>
                                </button>

                                <nav id="mobile-nav" className="headerNav__mobile nav-menu" style={this.props.disableHeaderNav ? {visibility: 'hidden'} : {}}>
                                    <MobileMenu />
                                </nav>
                            </div>
                        </div>
                    )}

                    {this.props.subNav ? (
                        <SubNav name={this.props.subNav}/>
                    ) : null}
                </header>
            </Headroom>
        )
    }

}

export default Header;



// WEBPACK FOOTER //
// ./frontend/components/Header/Header.jsx